var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c("v-col", { attrs: { cols: "6" } }),
          _c("v-col", { attrs: { cols: "6" } }, [
            _c("h2", { staticStyle: { "text-align": "center" } }, [
              _vm._v(_vm._s(_vm.date) + " " + _vm._s(_vm.time)),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "v-row",
        _vm._l(_vm.charts[0], function (data, index) {
          return _c(
            "v-col",
            { key: "" + index + data, attrs: { cols: "12", sm: "6" } },
            [
              _vm.charts[1][index].title === "Installed Capacity By Fuel Type"
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-select", {
                            attrs: {
                              label: "Chart Type",
                              items: _vm.installedCapChartTypeItems,
                            },
                            model: {
                              value: _vm.installedCapChartType,
                              callback: function ($$v) {
                                _vm.installedCapChartType = $$v
                              },
                              expression: "installedCapChartType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("Plotly", {
                attrs: {
                  data: data,
                  layout: _vm.charts[1][index],
                  toImageButtonOptions: _vm.chartDownloadName(
                    _vm.caseName,
                    "AA",
                    _vm.charts[1][index].title
                  ),
                },
              }),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }